import { render, staticRenderFns } from "./platformUseTutorial.vue?vue&type=template&id=7a060471&scoped=true&"
import script from "./platformUseTutorial.vue?vue&type=script&lang=js&"
export * from "./platformUseTutorial.vue?vue&type=script&lang=js&"
import style0 from "./platformUseTutorial.vue?vue&type=style&index=0&id=7a060471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a060471",
  null
  
)

export default component.exports